import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApisService } from '@core/services/apis.service';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-add-job-titles',
  templateUrl: './add-job-titles.component.html',
  styleUrls: ['./add-job-titles.component.scss']
})
export class AddJobTitlesComponent implements OnInit {

     productId: string | null = null;
 
 
    JobTitleId: string | null = null;
 
   formData: any = {
    name_ar: '',
    name_en: '',
     job_title_id: ''
   };
 
  //  jobTitles = [
  //    { id: 1, name: 'Software Engineer' },
  //    { id: 2, name: 'Project Manager' },
  //    { id: 3, name: 'UI/UX Designer' }
  //  ];
  jobTitle: any;
 
 
 constructor(
     private route: ActivatedRoute,
     private router: Router,
     private apiService: ApisService,
     private toastr: ToastrService,
      private translate: TranslateService
   ) {}
     ngOnInit(): void {
     // get product id from route
    this.JobTitleId = this.route.snapshot.paramMap.get('id');
     if (this.JobTitleId) {
       this.loadjobTitle(this.JobTitleId);
     }
 
           this.fetchJobTitles();
 
         
   }
 
 
       fetchJobTitles(): void {
     this.apiService.getJobTitles().subscribe({
       next: (res) => (this.jobTitle = res),
       error: () => this.toastr.error('Failed to load job titles')
     });
   }
 
   loadjobTitle(id: string): void {
     this.apiService.getJobTitleById(id).subscribe({
       next: (res: any) => {
         this.jobTitle = res;
         console.log(this.jobTitle ,'this.jobTitle')
       },
       error: (err) => {
         console.error('Failed to load jobTitle:', err);
        //  this.toastr.error('Failed to load jobTitle details');
       }
     });
   }
 
  //    onFileSelected(event: any): void {
  //    if (event.target.files.length > 0) {
  //      this.jobTitles.image = event.target.files[0];
  //    }
  //  }
   // Update product
 
onSubmit(): void {
  const form = new FormData();
  form.append('name_en', this.formData.name_en);
  form.append('name_ar', this.formData.name_ar);

  this.apiService.addJobTitles(form).subscribe({
    next: () => {
      this.toastr.success(this.translate.instant('MENU.DASHBOARD.job_title_added_successfully'));
      this.router.navigate(['/job-title']);
    },
    error: (err) => {
      console.error('Add job title failed:', err);
      this.toastr.error(this.translate.instant('MENU.DASHBOARD.failed_to_add_job_title'));
    }
  });
}

 
 cancel(): void {
    this.router.navigate(['/job-title']);
  }

  
}
